import React from 'react'
import { ConfigProvider } from 'antd'
import { IntlProvider } from 'react-intl'
import { connect } from 'react-redux'

import english from './locales/en-US'
import italian from './locales/it-IT'
import spanish from './locales/es-ES'
import french from './locales/fr-FR'
import german from './locales/de-DE'

const locales = {
  en: english,
  it: italian,
  es: spanish,
  fr: french,
  de: german,
}

const Localization = ({ children, user }) => {
  const currentLocale = locales[user.locale || 'it']
  return (
    <ConfigProvider locale={currentLocale.localeAntd}>
      <IntlProvider locale={currentLocale.locale} messages={currentLocale.messages}>
        {children}
      </IntlProvider>
    </ConfigProvider>
  )
}
const mapStateToProps = ({ user }) => ({ user })
export default connect(mapStateToProps)(Localization)
